import { render, staticRenderFns } from "./preguntas-predefinidas.vue?vue&type=template&id=37f6b775&scoped=true&"
import script from "./preguntas-predefinidas.vue?vue&type=script&lang=ts&"
export * from "./preguntas-predefinidas.vue?vue&type=script&lang=ts&"
import style0 from "./preguntas-predefinidas.vue?vue&type=style&index=0&id=37f6b775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6b775",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VList,VListItem,VRow,VSkeletonLoader,VSpacer})
